var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyTemplateList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 80,
    viewBox: "0 0 87 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.2097,
    y: 1.72338,
    width: 59.9072,
    height: 12.1845,
    rx: 1.01538,
    stroke: "#8F96A4",
    strokeWidth: 2.03075
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0322 14.9233H2.87841C2.33982 14.9233 1.82329 14.7093 1.44245 14.3285C1.06161 13.9477 0.847656 13.4311 0.847656 12.8925V2.73876C0.847656 2.20017 1.06161 1.68364 1.44245 1.3028C1.82329 0.921962 2.33982 0.708008 2.87841 0.708008H13.0322C13.5708 0.708008 14.0873 0.921962 14.4681 1.3028C14.849 1.68364 15.0629 2.20017 15.0629 2.73876V12.8925C15.0629 13.4311 14.849 13.9477 14.4681 14.3285C14.0873 14.7093 13.5708 14.9233 13.0322 14.9233ZM2.87841 2.73876V12.8925H13.0322V2.73876H2.87841ZM6.93992 11.2293L4.1984 8.54164L5.61993 7.08965L6.93992 8.3802L10.2907 5.06296L11.7122 6.50683L6.93992 11.2283V11.2293Z",
    fill: "#8F96A4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2097,
    y: 23.3552,
    width: 59.9072,
    height: 12.1845,
    rx: 1.01538,
    stroke: "#8F96A4",
    strokeWidth: 2.03075
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0322 36.5551H2.87841C2.33982 36.5551 1.82329 36.3412 1.44245 35.9603C1.06161 35.5795 0.847656 35.063 0.847656 34.5244V24.3706C0.847656 23.832 1.06161 23.3155 1.44245 22.9346C1.82329 22.5538 2.33982 22.3398 2.87841 22.3398H13.0322C13.5708 22.3398 14.0873 22.5538 14.4681 22.9346C14.849 23.3155 15.0629 23.832 15.0629 24.3706V34.5244C15.0629 35.063 14.849 35.5795 14.4681 35.9603C14.0873 36.3412 13.5708 36.5551 13.0322 36.5551ZM2.87841 24.3706V34.5244H13.0322V24.3706H2.87841ZM6.93992 32.8612L4.1984 30.1735L5.61993 28.7215L6.93992 30.012L10.2907 26.6948L11.7122 28.1387L6.93992 32.8602V32.8612Z",
    fill: "#8F96A4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2097,
    y: 44.9871,
    width: 59.9072,
    height: 12.1845,
    rx: 1.01538,
    stroke: "#8F96A4",
    strokeWidth: 2.03075
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0322 58.187H2.87841C2.33982 58.187 1.82329 57.973 1.44245 57.5922C1.06161 57.2113 0.847656 56.6948 0.847656 56.1562V46.0024C0.847656 45.4638 1.06161 44.9473 1.44245 44.5665C1.82329 44.1856 2.33982 43.9717 2.87841 43.9717H13.0322C13.5708 43.9717 14.0873 44.1856 14.4681 44.5665C14.849 44.9473 15.0629 45.4638 15.0629 46.0024V56.1562C15.0629 56.6948 14.849 57.2113 14.4681 57.5922C14.0873 57.973 13.5708 58.187 13.0322 58.187ZM2.87841 46.0024V56.1562H13.0322V46.0024H2.87841ZM6.93992 54.493L4.1984 51.8053L5.61993 50.3533L6.93992 51.6439L10.2907 48.3266L11.7122 49.7705L6.93992 54.492V54.493Z",
    fill: "#8F96A4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2097,
    y: 66.6194,
    width: 59.9072,
    height: 12.1845,
    rx: 1.01538,
    stroke: "#8F96A4",
    strokeWidth: 2.03075
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0322 79.8193H2.87841C2.33982 79.8193 1.82329 79.6053 1.44245 79.2245C1.06161 78.8436 0.847656 78.3271 0.847656 77.7885V67.6348C0.847656 67.0962 1.06161 66.5796 1.44245 66.1988C1.82329 65.818 2.33982 65.604 2.87841 65.604H13.0322C13.5708 65.604 14.0873 65.818 14.4681 66.1988C14.849 66.5796 15.0629 67.0962 15.0629 67.6348V77.7885C15.0629 78.3271 14.849 78.8436 14.4681 79.2245C14.0873 79.6053 13.5708 79.8193 13.0322 79.8193ZM2.87841 67.6348V77.7885H13.0322V67.6348H2.87841ZM6.93992 76.1253L4.1984 73.4376L5.61993 71.9856L6.93992 73.2762L10.2907 69.959L11.7122 71.4028L6.93992 76.1243V76.1253Z",
    fill: "#8F96A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTemplateList);
export default __webpack_public_path__ + "static/media/empty-template-list.32e6f85d.svg";
export { ForwardRef as ReactComponent };